import i18n from "i18next";
import { reactI18nextModule } from "react-i18next";
import translationEN from "./locales/en.json";
import getLanguage from "./helpers/getLanguage";
import translationDe from "./locales/de.json";

// the translations
const resources = {
  en: {
    translation: translationEN,
  },
  de: {
    translation: translationDe,
  },
};

i18n
  .use(reactI18nextModule) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: "de",
    lng: getLanguage(),
    saveMissing: true,
    debug: true,
    // keySeparator: false,  we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

export default i18n;



// WEBPACK FOOTER //
// ./src/i18n.js